import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, ToastController, ViewController, AlertController, LoadingController, ActionSheetController } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';

import { Storage } from '@ionic/storage';

import { PunchCard } from '../../models/punch-card';
import { BusinessPunchCardManagerHandler } from '../../providers/business-punch-card-handler';

import { BusinessPunchCardSequenceManagerPage } from '../business-punch-card-sequence-manager/business-punch-card-sequence-manager';

import { BusinessPunchCardListPage } from '../business-punch-card-list/business-punch-card-list';

import { Camera, CameraOptions } from '@ionic-native/camera';

import { Globals } from '../../providers/globals';



@Component({
  selector: 'page-business-punch-card-manager',
  templateUrl: 'business-punch-card-manager.html',
})
export class BusinessPunchCardManagerPage {
	@ViewChild('fileInput') fileInput;

	punchCard: PunchCard;
	sequences: any;
	hasSequences: boolean;
	hasPunches: boolean;
	private punchCardManagerForm : FormGroup;
	public imageSrc: string;
	loader: any;
	filePath: any;
	isLoading: boolean = false;
	saveIsLoading: boolean = false;
	deleteIsLoading: boolean = false;
	imageChanging: boolean = false;
	isPublishing: boolean = false;
	hasExpirationDate: boolean = false;
	currentYear : any = (new Date()).getFullYear();
	futureYear: any = (this.currentYear + 10);

  	constructor(  		
  		private toastCtrl: ToastController,
		public navCtrl: NavController, 
		public viewCtrl: ViewController,
		public navParams: NavParams,
		private formBuilder: FormBuilder,
		public punchCardManagerHandler: BusinessPunchCardManagerHandler,
		public storage: Storage,
		private camera: Camera,
		public loadingCtrl: LoadingController,
		public alertCtrl: AlertController,
		public globals: Globals,
		public actionSheetCtrl: ActionSheetController,
		public _DomSanitizer: DomSanitizer
		) {
		// this.filePath = this.globals.fileUrl;

		this.punchCard = navParams.get('punchCard');
		
	    this.punchCardManagerForm = this.formBuilder.group({
	    	"Id": [''],
		  	"PunchCardName":  ['', Validators.required],
		  	"ImagePath":  [''],
		    "IsPublished": [false],
		    "IsActive": [true],
		    "HasExpirationDate": [false],
		    "ExpirationDate": [''],
		    "HasCustomImage": [false]
	   	});   
	}

	ionViewWillEnter() {
		// console.log("hey");
		if(this.punchCard.Id){

	   		this.loadPunchCard(this.punchCard.Id);

	    } else {
	    	this.sequences = []
	    }
		// this.loadPunchCard(this.punchCard.Id);
	}

	ionViewDidLoad() {
		console.log('ionViewDidLoad BusinessPunchCardManagerPage');
	}

	manageSequence($e, sequence){
		// this.punchCardManagerHandler.validateSequence(sequence.Id, (result)=>{
		//   	if(result.Success){
		  		this.navCtrl.push(BusinessPunchCardSequenceManagerPage, {
			      punchCardSequence: sequence
			    });
		//   	} else {
		  		
		//   		let alert = this.alertCtrl.create({
	 //              title: 'Error',
	 //              subTitle: result.Message,
	 //              buttons: ['Ok']
	 //            });

	 //            alert.present();
		//   	}
		// })
	}

	publishCardCancelled: any=false;

	respondTryPublish($toggle, resp){
		var msg = ($toggle.value) ? "Reward published." : "Reward unpublished.";

		if(resp.Message!="" && resp.Message!=null){
			msg = resp.Message;
			this.publishCardCancelled = true;
			$toggle.value = false;			

	  		let alert = this.alertCtrl.create({
              title: 'Error',
              subTitle: msg,
              buttons: ['Ok']
            });

            alert.present();	            			
		}else{
			let toast = this.toastCtrl.create({
				message: msg,
				duration: 3000,
				position: 'bottom'
			});

			toast.present();					
		}			
	}

	tryPublish($toggle) {
		if(this.publishCardCancelled){
			this.publishCardCancelled = false;
			return;
		}

		//Verify if user can publish card
		var isPublished = $toggle.value;
		
		var cb = ()=>{
			this.isPublishing = true;

			this.punchCardManagerHandler.publishPunchCard({
				id: this.punchCard.Id,
				publish: isPublished,
				cb: (resp)=>{	
					this.isPublishing = false;
					
					this.respondTryPublish($toggle, resp);
				}
			})			
		}

		var msg = "";

		if($toggle.value){
			msg = "This will make the reward available to the world, are you sure?";
		}else{
			msg = "This will make the reward hidden from the world, are you sure?";
		}

		if($toggle.value) {
		  let alert = this.alertCtrl.create({
		    title: 'Reward Visibility',
		    message: msg,
		    buttons: [
		      {
		        text: 'Cancel',
		        role: 'cancel',
		        handler: () => {
		        	this.publishCardCancelled = true;
					$toggle.value = ($toggle.value) ? false : true;
		        }
		      },
		      {
		        text: 'Confirm',
		        handler: () => {		        	
		          	cb();
		        }
		      }
		    ]
		  });
		  alert.present();
		}else{
			cb();
		}
	}

	createPunchCardSequence(){
		this.navCtrl.push(BusinessPunchCardSequenceManagerPage, {
	      punchCardSequence: {},
	      punchCardId: this.punchCard.Id
	    });
	}

	loadPunchCard(id){
		this.isLoading = true;

		this.punchCardManagerHandler.getPunchCard(id, (result)=>{
		  	
		  	if(result.punchCard.Id != ''){
		  		this.punchCard = result.punchCard;

		  		this.punchCardManagerForm.patchValue(
		    			this.punchCard
		    	)

		    	let expirationDate = result.punchCard.ExpirationDate ? (new Date(result.punchCard.ExpirationDate)).toLocaleDateString() : '';

		  		this.punchCardManagerForm.patchValue({
		  			"ExpirationDate": expirationDate,
		  			"HasExpirationDate": (expirationDate != '')
		  		})

		    	this.sequences = result.punchCardSequenceListV2;

		    	this.hasSequences = this.sequences.length > 0;

		    	if(this.punchCard.HasCustomImage)
		  			this.filePath = this.globals.fileUrl + this.punchCard.ImagePath;

		  		this.imageSrc = null;
		    	
		  	}

		  	this.isLoading = false;
		})
	}

	createPunchArray(punchQuantity){
		var punches = new Array(punchQuantity);

		return punches;
	}

	presentActionSheet() {
	   let actionSheet = this.actionSheetCtrl.create({
	     title: 'Choose the source for an image',
	     buttons: [
	       {
	         text: 'Camera',
	         handler: () => {
	           console.log('Archive clicked');

	           this.getImage(true)
	         }
	       },
	       {
	         text: 'Image Gallery',
	         handler: () => {
	           console.log('Archive clicked');

	           this.getImage(false)
	         }
	       },
	       {
	         text: 'Cancel',
	         role: 'cancel',
	         handler: () => {
	           console.log('Cancel clicked');
	         }
	       }
	     ]
	   });

	   actionSheet.present();
	}

	deletePunchCard(){
		this.deleteIsLoading = true;
		
		this.punchCardManagerHandler.deletePunchCard(this.punchCard.Id, (result)=>{
			this.deleteIsLoading = true;

			if(result.Success)
				this.navCtrl.pop();
			else{
				let alert = this.alertCtrl.create({
	              title: 'Error',
	              subTitle: result.Message,
	              buttons: ['Ok']
	            });

	            alert.present();
			}
		});			
	}

	presentDeleteConfirmation() {
	  let alert = this.alertCtrl.create({
	    title: 'Confirm deletion',
	    message: 'Do you want to delete this reward?',
	    buttons: [
	      {
	        text: 'Delete',
	        handler: () => {
	          console.log('Delete clicked');
	          this.deletePunchCard()
	        }
	      },
	      {
	        text: 'Cancel',
	        role: 'cancel',
	        handler: () => {
	          console.log('Cancel clicked');
	        }
	      }
	    ]
	  });
	  alert.present();
	}

	onSubmit(){
		this.saveIsLoading = true;

		if(!this.punchCardManagerForm.value.HasExpirationDate)
			this.punchCardManagerForm.patchValue({"ExpirationDate": ''})

		if(this.punchCardManagerForm.value.Id != ''){

			console.log("entered update");

			this.punchCardManagerHandler.udpatePunchCard(this.punchCardManagerForm.value.Id, this.punchCardManagerForm.value, (result)=>{
				if(result.Success){
					let toast = this.toastCtrl.create({
						message: 'Reward has been updated',
						duration: 3000,
						position: 'bottom'
					});

					toast.present();						
				} else {
					let alert = this.alertCtrl.create({
				    	title: 'Error',
				    	subTitle: result.Message,
				    	buttons: ['Ok']
				  	});
				  	
				  	alert.present();
				}

				this.saveIsLoading = false;
			})

		} else {
			console.log("entered create");

			this.punchCardManagerHandler.createPunchCard(this.punchCardManagerForm.value, (result)=>{
				if(result.Success){
					this.loadPunchCard(result.Data.Id);
				} else {
					let alert = this.alertCtrl.create({
				    	title: 'Error',
				    	subTitle: result.Message,
				    	buttons: ['Ok']
				  	});
				  	
				  	alert.present();
				}
			  				  	
				this.saveIsLoading = false;
			})
		}		  	
	}

	private getImage (fromCamera): void {
		var sourceType = fromCamera ? this.camera.PictureSourceType.CAMERA : this.camera.PictureSourceType.PHOTOLIBRARY

		const options: CameraOptions = {
	  	  	sourceType: sourceType,
		  	destinationType: this.camera.DestinationType.DATA_URL,  
		    mediaType: this.camera.MediaType.PICTURE,    
		    allowEdit: true,
		    quality: 30,
		    targetWidth: 500,
		    targetHeight: 500,
		    encodingType: this.camera.EncodingType.PNG,      
		    correctOrientation: true
		}

		this.imageChanging = true;

		this.camera.getPicture(options).then((dataUrl) => {
			if(!this.filePath){
				let imageData = 'data:image/png;base64,' + dataUrl;

		    	this.imageSrc = imageData;

		    	var imgObject = {
			    	"ImagePath": imageData,
			    }

		    	this.punchCardManagerForm.patchValue(
		    		imgObject
		    	) 

		    }


			if(this.punchCard.Id){

	    		this.punchCardManagerHandler
	    		.updatePunchCardImage({
	    			id: this.punchCard.Id,
	    			imageString: 'data:image/png;base64,' + dataUrl,
	    			cb: (data)=>{ 
						

						console.log("New image path: " + data.Data);

						this.punchCard.ImagePath = data.Data;
						this.punchCard.HasCustomImage = true

						var imgObject = {
				    		"ImagePath": data.Data,
				    		"HasCustomImage": true
				    	}

				    	console.log(imgObject);

				    	this.punchCardManagerForm.patchValue(
				    		imgObject
				    	) 

				    	this.imageSrc = null

				    	this.filePath = this.globals.fileUrl + this.punchCard.ImagePath;

				    	this.imageChanging = false;
					}
				})
	    	}
	    	// 		cb: (data)=>{

	    	// 			console.log("New image path: " + data.Data);

	    	// 			this.punchCard.ImagePath = data.Data;

	    	// 			this.punchCard.HasCustomImage = true

						// var imgObject = {
				  //   		"ImagePath": data.Data,
				  //   		"HasCustomImage": true
				  //   	}

				  //   	console.log(imgObject);

				  //   	this.punchCardManagerForm.patchValue(
				  //   		imgObject
				  //   	) 

				  //   	this.filePath = this.globals.fileUrl + this.punchCard.ImagePath;

				  //   	this.imageChanging = false;
	    	// 		}
	    		// })
			// } else {
			// 	 // dataUrl is either a base64 encoded string or a file URI
			// 	 // If it's base64:
			// 	 let base64img = 'data:image/png;base64,' + dataUrl;

			// 	 this.imageSrc = base64img;

			// 	 var imgObject = {
			//     		"ImagePath": base64img,
			//     }

		 //    	this.punchCardManagerForm.patchValue(
		 //    		imgObject
		 //    	) 

		 //    	this.imageChanging = false;
		 //    }

			}, (err) => {
			 // Handle error
			 alert('Unable to take photo');
			 this.imageChanging = false;
			});
	}

	getPicture() {
	    if (Camera['installed']()) {

	      this.presentActionSheet();
	    
	    } else {
	      
	      this.fileInput.nativeElement.click();
	    
	    }
	}

	processWebImage(event) {
	    let reader = new FileReader();

	    reader.onload = (readerEvent) => {

		    let imageData = (readerEvent.target as any).result;

		    if(!this.filePath){

		    	this.imageSrc = imageData;

		    	var imgObject = {
			    	"ImagePath": imageData,
			    }

		    	this.punchCardManagerForm.patchValue(
		    		imgObject
		    	) 

		    }

		    if(this.punchCard.Id){

			    this.imageChanging = true;

				this.punchCardManagerHandler
				.updatePunchCardImage({
					id: this.punchCard.Id,
					imageString: imageData,
					cb: (data)=>{ 
						this.imageChanging = false;

						console.log("New image path: " + data.Data);

						this.punchCard.ImagePath = data.Data;
						this.punchCard.HasCustomImage = true

						var imgObject = {
				    		"ImagePath": data.Data,
				    		"HasCustomImage": true
				    	}

				    	console.log(imgObject);

				    	this.punchCardManagerForm.patchValue(
				    		imgObject
				    	) 

				    	this.imageSrc = null

				    	this.filePath = this.globals.fileUrl + this.punchCard.ImagePath;
					}
				})
			}
	    }; 

	    reader.readAsDataURL(event.target.files[0]);
	}

	getProfileImageStyle() {
	    // return 'url(' + this.form.controls['profilePic'].value + ')'
	    return this.punchCardManagerForm.controls['ImagePath'].value
	}

}


// WEBPACK FOOTER //
// ./src/pages/business-punch-card-manager/business-punch-card-manager.ts